export enum ServiceStatusEnum {
  FullAdmission = "FullAdmission",
  OrientationProbation = "OrientationProbation",
  DropIn = "DropIn",
  Hotline = "Hotline",
  StreetOutreach = "StreetOutreach",
}
